/** Sentinel value used in CategoryMappingEditor when the user wants to create a new local category */
export const ADD_CATEGORY_VALUE = '__add__';
